import { feedbackUnreadCount } from '@/api/feedback'
const state = () => ({
  unreadCount: 0, //未读消息数量
  pullInterval: 100, //轮询时间
})

const mutations = {
  SET_PULL_INTERVAL(state, interval) {
    state.pullInterval = interval
  },
  SET_FEEDBACK_UNREADCOUNT(state, unreadCount) {
    state.unreadCount = unreadCount
  },
}

const actions = {
  async FETCH_FEEDBACK_UNREADCOUNT({ commit }) {
    // 发起 http 请求
    const { data } = await feedbackUnreadCount()
    commit('SET_FEEDBACK_UNREADCOUNT', data.unreadCount)
    commit('SET_PULL_INTERVAL', data.pullInterval)
    setTimeout(() => {
      this.dispatch('feedback/FETCH_FEEDBACK_UNREADCOUNT')
    }, data.pullInterval * 1000)
    return { data }
  },
}
const getters = {
  unreadCount: (state) => state.unreadCount,
  pullInterval: (state) => state.pullInterval,
}
export default { state, mutations, actions, getters }
